<template>
  <div class="bg-white">
    <caregiversaathi />
    <AboutFriends />
    <div class="lg:px-20 md:px-20 px-4 py-20 bg-white">
      <GratitudeFOCGS />
    </div>
    <Team />

    <div class="lg:py-20 md:py-12 bg-white">
      <!-- <Help /> -->
      <Donation />
    </div>
    <Updates />
    <LegalDocs />
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import caregiversaathi from "./components/frnd-caregiversaathi";
import Updates from "./components/Updates.vue";
import AboutFriends from "./components/AboutFriends.vue";
import Team from "./components/Team.vue";
import GratitudeFOCGS from "./components/GratitudeFOCGS.vue";
import LegalDocs from "./components/LegalDocs.vue";
import Donation from "./components/Donation.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";

export default {
  components: {
    caregiversaathi,
    Updates,
    AboutFriends,
    LegalDocs,
    GratitudeFOCGS,
    Donation,
    Team,
    DownloadApp,
    Footer,
  },
};
</script>
